(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-banner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nusswahn-cookie-banner')) {
    customElements.define(
      'nusswahn-cookie-banner',
      class extends HTMLElement {
        connectedCallback() {
          this.acceptButton = this.querySelector('[data-cookie-accept]');
          this.declineButton = this.querySelector('[data-cookie-decline]');
          this.saveButton = this.querySelector('[data-cookie-save]');
          this.analyticsInput = this.querySelector('[data-cookie-analytics]');
          this.marketingInput = this.querySelector('[data-cookie-marketing]');

          this.acceptButton?.addEventListener('click', () => this.decide(true, true, this.acceptButton));
          this.declineButton?.addEventListener('click', () => this.decide(false, false, null));
          this.saveButton?.addEventListener('click', () =>
            this.decide(this.analyticsInput?.checked, this.marketingInput?.checked, this.saveButton)
          );
          this.querySelector('[data-cookie-customize]')?.addEventListener('click', () => {
            this.classList.add('is-settings');
          });

          // Footer-Link „Cookie-Einstellungen" öffnet den Banner jederzeit wieder.
          this.onDocumentClick = (event) => {
            const trigger = event.target.closest('[data-cookie-settings-open]');
            if (!trigger) return;
            event.preventDefault();
            this.open(true);
          };
          document.addEventListener('click', this.onDocumentClick);

          // Im Theme-Editor nie automatisch aufspringen.
          if (window.Shopify && window.Shopify.designMode) return;

          // Bewusst NICHT über shouldShowBanner() gegatet: Das spiegelt die Region-
          // Konfiguration im Admin und lieferte auf diesem Store false, obwohl keine
          // Entscheidung vorlag. Der Shop verkauft nur nach Deutschland; DSGVO gilt
          // damit praktisch für alle Besucher. Regel: zeigen, solange keine
          // Entscheidung gespeichert ist.
          this.withPrivacyApi((api) => {
            const consent = this.currentConsent(api);
            if (consent.analytics !== '' || consent.marketing !== '') return;
            this.open(false);
          });
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onDocumentClick);
        }

        withPrivacyApi(callback) {
          if (window.Shopify && window.Shopify.customerPrivacy) {
            callback(window.Shopify.customerPrivacy);
            return;
          }
          if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
            if (error || !window.Shopify.customerPrivacy) return;
            callback(window.Shopify.customerPrivacy);
          });
        }

        currentConsent(api) {
          try {
            return api.currentVisitorConsent() || {};
          } catch (error) {
            return {};
          }
        }

        open(withSettings) {
          this.hidden = false;
          this.classList.add('is-hidden');
          this.classList.toggle('is-settings', Boolean(withSettings));
          // Blendet mobil das Trusted-Shops-Badge aus, siehe Stylesheet.
          document.documentElement.dataset.cookieBanner = 'open';
          if (withSettings) {
            this.withPrivacyApi((api) => {
              const consent = this.currentConsent(api);
              if (this.analyticsInput) this.analyticsInput.checked = consent.analytics === 'yes';
              if (this.marketingInput) this.marketingInput.checked = consent.marketing === 'yes';
            });
          }
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.classList.remove('is-hidden');
              this.classList.add('is-open');
            });
          });
        }

        decide(analytics, marketing, morphButton) {
          this.withPrivacyApi((api) => {
            api.setTrackingConsent(
              {
                analytics: Boolean(analytics),
                marketing: Boolean(marketing),
                preferences: Boolean(analytics),
                sale_of_data: Boolean(marketing),
              },
              () => {}
            );
          });

          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (morphButton && !reduceMotion) {
            morphButton.classList.add('is-done');
            window.setTimeout(() => this.dismiss(), 950);
          } else {
            this.dismiss();
          }
        }

        dismiss() {
          this.classList.add('is-hidden');
          this.classList.remove('is-open');
          window.setTimeout(() => {
            this.hidden = true;
            this.classList.remove('is-settings');
            this.acceptButton?.classList.remove('is-done');
            this.saveButton?.classList.remove('is-done');
            // Erst nach dem Ausflug, sonst taucht das Badge unter der noch
            // sichtbaren Karte wieder auf.
            delete document.documentElement.dataset.cookieBanner;
          }, 500);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-box-included-list"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nusswahn-box-chips')) {
    customElements.define(
      'nusswahn-box-chips',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();
          const optionen = { signal: this.controller.signal };

          // Maus und Tastatur öffnen beim Überfahren beziehungsweise beim Fokus,
          // Touch braucht den Klick. pointerType trennt beides sauber.
          this.addEventListener(
            'pointerover',
            (ereignis) => {
              if (ereignis.pointerType === 'touch') return;
              this.zeige(ereignis.target.closest('[data-chip]'));
            },
            optionen,
          );
          this.addEventListener(
            'pointerleave',
            (ereignis) => {
              if (ereignis.pointerType === 'touch') return;
              this.zeige(null);
            },
            optionen,
          );
          this.addEventListener('focusin', (ereignis) => this.zeige(ereignis.target.closest('[data-chip]')), optionen);
          this.addEventListener(
            'focusout',
            (ereignis) => {
              if (this.contains(ereignis.relatedTarget)) return;
              this.zeige(null);
            },
            optionen,
          );
          this.addEventListener(
            'click',
            (ereignis) => {
              const pille = ereignis.target.closest('[data-chip]');
              if (!pille) return;
              // Mit der Maus hat das Überfahren schon geöffnet; ein Umschalten würde
              // die Vorschau ausgerechnet beim Klick wieder zuklappen. Touch und
              // Tastatur schalten dagegen um, sie haben kein Überfahren.
              if (ereignis.pointerType === 'mouse') {
                this.zeige(pille);
                return;
              }
              this.zeige(this.aktiv === pille ? null : pille);
            },
            optionen,
          );

          document.addEventListener(
            'click',
            (ereignis) => {
              if (this.contains(ereignis.target)) return;
              this.zeige(null);
            },
            optionen,
          );
          document.addEventListener(
            'keydown',
            (ereignis) => {
              if (ereignis.key === 'Escape') this.zeige(null);
            },
            optionen,
          );
        }

        disconnectedCallback() {
          this.controller?.abort();
        }

        zeige(pille) {
          if (this.aktiv === pille) return;
          if (this.aktiv) {
            this.aktiv.setAttribute('aria-expanded', 'false');
            this.aktiv.parentElement.removeAttribute('data-open');
          }
          this.aktiv = pille || null;
          if (!pille) return;
          this.platziere(pille.parentElement);
          pille.setAttribute('aria-expanded', 'true');
          pille.parentElement.setAttribute('data-open', '');
        }

        /*
         * Die Vorschau muss innerhalb der klemmenden Sektion bleiben: Sowohl der
         * Produktkopf als auch der Detailbereich tragen overflow: clip, oberhalb der
         * ersten Pillenreihe wäre sie sonst angeschnitten. Nach oben wird deshalb
         * geklappt, nach den Seiten verschoben. Gemessen wird mit offsetWidth/Height,
         * die Rechtecke tragen im Ruhezustand noch die Skalierung der Animation.
         */
        platziere(eintrag) {
          const vorschau = eintrag.querySelector('[data-preview]');
          if (!vorschau) return;
          eintrag.removeAttribute('data-below');
          eintrag.style.setProperty('--box-preview-shift', '0px');

          const rand = 12;
          const pille = eintrag.getBoundingClientRect();
          const klemme = this.klemmflaeche();
          const hoehe = vorschau.offsetHeight;
          const platzOben = pille.top - klemme.top;
          const platzUnten = klemme.bottom - pille.bottom;
          if (platzOben < hoehe + rand && platzUnten > platzOben) {
            eintrag.setAttribute('data-below', '');
          }

          const breite = vorschau.offsetWidth;
          const mitte = pille.left + pille.width / 2;
          const links = mitte - breite / 2;
          const rechts = mitte + breite / 2;
          let versatz = 0;
          if (links < rand) versatz = rand - links;
          else if (rechts > window.innerWidth - rand) versatz = window.innerWidth - rand - rechts;
          if (versatz) eintrag.style.setProperty('--box-preview-shift', `${Math.round(versatz)}px`);
        }

        klemmflaeche() {
          let element = this.parentElement;
          while (element && element !== document.body) {
            if (getComputedStyle(element).overflow !== 'visible') return element.getBoundingClientRect();
            element = element.parentElement;
          }
          return { top: 0, bottom: window.innerHeight };
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    const QUICK_ADD_DONE_DELAY = 1600;
  const QUICK_ADD_ERROR_DELAY = 6000;

  const initializeQuickAdd = (root = document) => {
    root.querySelectorAll('.product-card__form:not([data-ready])').forEach((form) => {
      form.dataset.ready = 'true';
      const button = form.querySelector('.product-card__quick-add');
      const card = form.closest('.product-card');
      const status = card ? card.querySelector('[data-quick-add-status]') : null;
      let doneTimer = null;
      let statusTimer = null;

      const clearStatus = () => {
        if (!status) return;
        status.textContent = '';
        status.hidden = true;
      };

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!button || button.disabled) return;
        window.clearTimeout(doneTimer);
        window.clearTimeout(statusTimer);
        clearStatus();
        button.classList.remove('is-done');
        button.classList.add('is-busy');
        button.disabled = true;
        try {
          const formData = new FormData(form);
          if (window.nusswahnCartSectionId) {
            formData.append('sections', window.nusswahnCartSectionId);
            formData.append('sections_url', window.location.pathname);
          }
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message);
          document.dispatchEvent(new CustomEvent('product:added', { detail: result }));
          button.classList.add('is-done');
          doneTimer = window.setTimeout(() => button.classList.remove('is-done'), QUICK_ADD_DONE_DELAY);
        } catch (error) {
          console.error(error);
          if (status) {
            // Reveal the live region before filling it so screen readers announce the change.
            status.hidden = false;
            status.textContent = status.dataset.quickAddError || '';
            statusTimer = window.setTimeout(clearStatus, QUICK_ADD_ERROR_DELAY);
          }
        } finally {
          button.classList.remove('is-busy');
          button.disabled = false;
        }
      });
    });
  };

  initializeQuickAdd();
  document.addEventListener('shopify:section:load', (event) => initializeQuickAdd(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text-highlight"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nw-text-highlight')) {
    customElements.define(
      'nw-text-highlight',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.hasAttribute('data-highlight-animation')) return;

          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduceMotion || !('IntersectionObserver' in window)) return;

          this.setAttribute('data-highlight-animate', '');
          this.highlightObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                requestAnimationFrame(() => {
                  this.classList.add('is-visible');
                  this.highlightObserver?.disconnect();
                });
              });
            },
            { threshold: 0.65 }
          );
          this.highlightObserver.observe(this);
        }

        disconnectedCallback() {
          this.highlightObserver?.disconnect();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
